export const INTERACTION_STATE = {
  inConference: 'e8980bdc-fe72-4856-8e4e-4df3975ad58d',
  consulting: '8d8b30b4-8bc9-40da-b2a0-206126f4f078',
  offered: 'ebb84637-cebb-469e-bba8-5937b463e12f',
  handling: '0e0af19c-97ca-4d04-a308-c948b6e14de9',
  missed: '8ae63359-314b-4244-938a-96c54b7d671c',
  rejected: '9956a6df-9d59-4467-ac08-b599764b19f8',
  handled: '0b5fa4aa-6699-433e-9739-c45db7443cf4',
  wrapUp: '14798386-f453-4720-b322-71d791eb1126',
  dialing: 'f004af45-41bd-480c-8ec8-580254dc1058',
  delegatedToSupervisor: '80f4a60a-4b59-49ed-ba4c-2c154118cb71',
  canceled: '99eed726-6b36-4db3-8212-dbc93558d9eb',
  preview: 'a3343f0a-3380-4982-8684-524d56b0f51a'
};

export const PENDING_STATUS = {
  delegateToSupervisor: 'DelegateToSupervisor'
};

export const COMPLETION_STATUS = {
  delegateToSupervisor: 'cca79be7-a4fc-4320-89bd-12ff86b26309',
  cancel: '7b0deffd-8b1b-48fb-b868-9d27e6db1c98'
};

export const INTERACTION_TRANSFER = {
  attended: 'attendedTransfer',
  blind: 'blindTransfer'
};

export const PARTY_TYPE = {
  customer: 'Customer',
  agent: 'Agent'
};

export const INTERACTION_VARIABLES = {
  TYPES: {
    simple: 'Simple',
    valueSet: 'ValueSet'
  },
  SIMPLE_SUB_TYPES: {
    text: 'Text',
    count: 'Count',
    money: 'Money',
    percentage: 'Percentage',
    flag: 'Flag',
    date_time: 'DateTime',
    timespan: 'Timespan'
  }
};
